import React from 'react';

import HeSignupTemplate from '../components/common/template/HeSignupTemplate';
import { useSignUp } from '../Hooks/useAuth';

const HeSignUpPage = () => {
  const {
    state,
    inputRef,
    onChangeValue,
    onClickSignupButton,
    isLoading,
    isValidateTrue,
    allowMarketing,
    allowMarketingCheck,
  } = useSignUp();

  return (
    <HeSignupTemplate
      state={state}
      inputRef={inputRef}
      onChangeValue={onChangeValue}
      onSignup={onClickSignupButton}
      isLoading={isLoading}
      isValidateTrue={isValidateTrue}
      allowMarketing={allowMarketing}
      allowMarketingCheck={allowMarketingCheck}
    />
  );
};

export default HeSignUpPage;
